// extracted by mini-css-extract-plugin
export default {"header":"forgetPass_header__5t6KG"};